'use strict';

var createjs = createjs || {};

createjs.MoveTransform = class extends createjs.BaseTransform {
	constructor(element) {
		super(element);

		this.el.borders.x = [];
		this.el.borders.y = [];

		this.el.fraction.move.x = 1;
		this.el.fraction.move.y = 1;

		this.el.fraction.release.x = 1;
		this.el.fraction.release.y = 1;

		_.bindAll(this, 'moveTo', 'getAcceleration', '_holdBorders', '_dispatchTweenUpdate', '_dispatchMoveComplete');
	}

	get MOVE() {
		return 'move'
	};

	get MOVE_COMPLETE() {
		return 'moveComplete'
	};

	moveTo(x, y, ease) {
		if(this.debug) console.log('moveTo');
		if (!(typeof TweenLite === 'undefined')) {
			var options = {};
			var speed = 0.45 + .01 * ((this.el.fraction.release.x + this.el.fraction.release.y) / 2) * this.el.fraction.base;

			if (!isNaN(x)) options.x = x;
			if (!isNaN(y)) options.y = y;
			if (ease) options.ease = ease;
			else options.ease = Cubic.easeOut;
			options.onComplete = this._dispatchMoveComplete;
			options.onUpdate = this._dispatchTweenUpdate;
			options.overwrite = 'auto';

			this._stopTween();
			if(this.useTween) this._tween = TweenLite.to(this.el, speed, options);
		}
	};

	getAcceleration() {
		if(this.debug) console.log('getAcceleration');

		var average = {x: 0, y: 0};

		if (this.el._stack && this.el._stack.length) {
			for (var i = 1, _len = this.el._stack.length; i < _len; i++) {
				average.x += (this.el._stack[i].x - this.el._stack[i - 1].x);
				average.y += (this.el._stack[i].y - this.el._stack[i - 1].y);
			}

			average.x /= this.el._stack.length;
			average.y /= this.el._stack.length;
		}

		var speed = 0 + Math.max(0, .1 * Math.abs((average.x + average.y) / 2));

		return speed;
	};

	_holdBorders() {
		//if(this.debug) console.log('_holdBorders');

		if (!this.el.free.x) {
			if (this.el.x < this.el.borders.x[0]) this.el.x = this.el.borders.x[0];
			else if (this.el.x > this.el.borders.x[1]) this.el.x = this.el.borders.x[1];
		}

		if (!this.el.free.y) {
			if (this.el.y < this.el.borders.y[0]) this.el.y = this.el.borders.y[0];
			else if (this.el.y > this.el.borders.y[1]) this.el.y = this.el.borders.y[1];
		}
	};

	_dispatchTweenUpdate() {
		//if(this.debug) console.log('_dispatchTweenUpdate');

		this._holdBorders();

		if (this.lock || this.el.lock ) {
			this._stopTween();
		}

		this.el.dispatchEvent(this.MOVE);
	};

	_dispatchMoveComplete() {
		if(this.debug) console.log('_dispatchMoveComplete');

		this.el.dispatchEvent(this.MOVE_COMPLETE);
	};

	_startTransform(evt) {
		if(this.debug) console.log('_startTransform');

		this._stopTween();
		if (this.el.bringToTop && this.el.parent) this.el.parent.setChildIndex(this.el, this.el.parent.getNumChildren() - 1);
	};

	_update(evt) {
		if(this.debug) console.log('_update');

		if (this.lock || this.el.lock ) return;

		// caluclate average movement between all points
		var average = {x: 0, y: 0};

		for (var pointerUID in this.el._fingers) {
			if (this.el._fingers[pointerUID].start) {
				average.x += (this.el._fingers[pointerUID].current.x - this.el._fingers[pointerUID].old.x);
				average.y += (this.el._fingers[pointerUID].current.y - this.el._fingers[pointerUID].old.y);
			}
		}

		average.x /= Math.max(1, this.el._activeFingers);
		average.y /= Math.max(1, this.el._activeFingers);

		this.el.x += (average.x * this.el.fraction.move.x * this.el.fraction.base);
		this.el.y += (average.y * this.el.fraction.move.y * this.el.fraction.base);

		this._holdBorders();

		this.el.dispatchEvent(this.MOVE);
	};

	_stopTransform(evt) {
		if(this.debug) console.log('_stopTransform');

		if (this.lock || this.el.lock ) return;

		if (this.el._stack.length == 0 || typeof TweenLite === 'undefined' || !this.useTween) {
			this._dispatchMoveComplete();
		} else if (!(typeof TweenLite === 'undefined')) {
			var options = {};
			var average = {x: 0, y: 0};
			var newPosition = {x: 0, y: 0};

			for (var i = 1, _len = this.el._stack.length; i < _len; i++) {
				average.x += (this.el._stack[i].x - this.el._stack[i - 1].x);
				average.y += (this.el._stack[i].y - this.el._stack[i - 1].y);
			}

			average.x = average.x / this.el._stack.length;
			average.y = average.y / this.el._stack.length;

			var fade = 10;

			var speed = 1 * ((this.el.fraction.release.x + this.el.fraction.release.y) / 2) * this.el.fraction.base;

			options.x = this.el.x + average.x * this.el.fraction.release.x * this.el.fraction.base * fade;
			options.y = this.el.y + average.y * this.el.fraction.release.y * this.el.fraction.base * fade;

			if (this.el.snap.x && this.el.snap.x != 0) {
				options.x = (Math.round(options.x / this.el.snap) * this.el.snap);
			}

			if (this.el.snap.y && this.el.snap.y != 0) {
				options.y = (Math.round(options.y / this.el.snap) * this.el.snap);
			}

			if (!this.el.free.x) {
				if (options.x < this.el.borders.x[0]) options.x = this.el.borders.x[0];
				else if (options.x > this.el.borders.x[1]) options.x = this.el.borders.x[1];
			}

			if (!this.el.free.y) {
				if (options.y < this.el.borders.y[0]) options.y = this.el.borders.y[0];
				else if (options.y > this.el.borders.y[1]) options.y = this.el.borders.y[1];
			}

			options.ease = Cubic.easeOut;
			options.onComplete = this._dispatchMoveComplete;
			options.onUpdate = this._dispatchTweenUpdate;
			options.overwrite = 'auto';

			this._stopTween();
			this._tween = TweenLite.to(this.el, speed, options);
		}
	};
}

